import { Image } from '@/components/Image'

import { SubHeading } from '@/components/Typography'

import { TabItemStyles } from './styles'
import { type TabItem } from './types'

interface Props {
  item: TabItem
}

const TabItem = ({ item }: Props) => (
  <TabItemStyles>
    <div className="tab-item__icon">
      {item.icon && <Image source={item.icon} width={40} height={40} alt="" layout="fixed" />}
    </div>
    <SubHeading tag="span" className="tab-item__label" emphasys color="dark-high">
      {item.label}
    </SubHeading>
  </TabItemStyles>
)

export default TabItem
